export const removeFromLocalStorage = (key) => {
  localStorage.removeItem(key);
};
